import { useEffect, useState } from 'react';
import './ScrollProgress.css';

function ScrollProgress() {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
            const percent = scrollableHeight > 0 ? (window.scrollY / scrollableHeight) * 100 : 0;
            setProgress(percent);
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className='scroll-progress-track'>
            <div className='scroll-progress-bar' style={{ width: `${progress}%` }} />
        </div>
    );
}

export default ScrollProgress;
